import type { RouteRecordRaw } from 'vue-router'
import { apiDocPages } from '@/modules/api/docs/registry'

// Страницы документации строятся из modules/api/docs/registry.ts: заголовок, оглавление по блокам
// страницы и переходы «назад/вперёд» по общему порядку.
const view = () => import('@/modules/api/views/ApiDocView/ApiDocView.vue')

const link = (index: number) => {
  const entry = apiDocPages[index]

  return entry ? { title: entry.title, to: `/api/${entry.path}` } : undefined
}

const apiChildrenRoutes: RouteRecordRaw[] = [
  ...apiDocPages.map((entry, index) => ({
    path: entry.path,
    name: entry.name,
    component: view,
    meta: {
      title: entry.title,
      page: entry.page,
      nav: entry.page.blocks.map(block => ({ title: block.nav ?? block.heading, to: `#${block.id}` })),
      prevRoute: link(index - 1),
      nextRoute: link(index + 1),
    },
  })),
  // Старый адрес страницы импорта каталога.
  { path: 'io/catalog', name: 'ioCatalog', redirect: { name: 'catalogApiImport' } },
]

const apiRoute: RouteRecordRaw[] = [
  {
    path: '/api',
    name: 'api',
    meta: {
      layout: 'ApiDocs',
    },
    redirect: { name: 'createWebhook' },
    children: apiChildrenRoutes,
  },
]

export default apiRoute
